import {
  notifyError,
  useNotifications,
  notifySuccess,
} from 'Logic/Notifications.js'
import { useMutation } from 'Data/Api'
import { normalizePath, useSetFlowTo } from 'Simple/Flow.js'
import mutation from './mutation.graphql.js'

export default function useDataOnSubmit(props, data, reExecuteQuery) {
  let [, notify] = useNotifications()
  let setFlowTo = useSetFlowTo(props.viewPath)

  let [, executeMutation] = useMutation(mutation)

  return async function onSubmit({ value, originalValue, args, change }) {
    switch (args.type) {
      case 'create-configuration': {
        let mutationResponse = await executeMutation({
          organization_id: value.organization_id,
          organization_locations: value.organization_locations,
          name: value.new_app_name,
        })

        if (mutationResponse.error) {
          notify(notifyError('Cannot create Leads App. Please try again.'))
          return
        }

        setFlowTo(normalizePath(props.viewPath, 'AddAction/AddDialog/No'))
        notify(notifySuccess('Lead App created.'))

        change(next => {
          next.configuration_id = mutationResponse.data.leads_create_app.id
          next.organization_id = null
          next.configuration_organization_id = value.organization_id
          next.organization_level = null
          next.organization_locations = []
          next.new_app_name = null
        })
        return
      }

      default: {
        return
      }
    }
  }
}
